<script setup lang="ts">
import {router, useForm, usePage} from "@inertiajs/vue3";
import ButtonComponent from "@components/button.vue";
import {computed} from "vue";

const page = usePage<any>();

const goToLogout = () => {
    localStorage.removeItem('token');
    return router.visit(route('postlogout'), {
        preserveState: false,
        preserveScroll: false,
    });
}

let loggedIn = computed(() => {
    return page.props.auth.user;
});

const goToAdmin = () => {
    return window.location.href = page.props.tenantUrl+'admin';
}

const goToWorkplaceManager = () => {
    return window.location.href = page.props.tenantUrl+'';
}

let currentTeam = computed(() => {

    if (page.props.auth.user) {
        page.props.auth.user.customers.forEach((customer) => {
            if (customer.pivot.isDefault === '1') {
                return customer.name;
            }
        });
    }

    return page.props.auth.user.customers[0].name;
});

let isAdmin = computed((): boolean => {
    return !!page.props.auth.user.roles.find((role) => role.name === 'admin');
});

let isManager = computed((): boolean => {
    return !!page.props.auth.user.roles.find((role) => role.name === 'company manager');
});

let hasActiveMembership = computed((): boolean => {
    return page.props.auth.user.membership.active;
});

</script>
<template>
    <section id="layouts-section-header">
        <div class="container">
            <div class="header-inner">
                <div class="header-left">
                    <div class="logo">
                        <img
                            :src="page.props.logo"
                            alt=""
                        >
                    </div>
                    <nav
                        v-if="loggedIn"
                    >
                        <button-component
                            color="outline-gray"
                            active-color="outline-purple"
                        >
                            App
                        </button-component>
                        <button-component
                            v-if="isManager"
                            @click="goToWorkplaceManager"
                            color="outline-gray"
                        >
                            Workplace manager
                        </button-component>
                        <button-component
                            v-if="isAdmin"
                            @click="goToAdmin"
                            color="outline-gray"
                        >
                            Admin
                        </button-component>
                    </nav>
                </div>
                <div class="header-right">
                    <div
                        v-if="loggedIn"
                        class="active-member">
                        <p class="type">
                            <template
                                v-if="hasActiveMembership"
                            >
                                Active member
                            </template>
                            <template
                                v-else
                            >
                                Visitor pass
                            </template>
                        </p>
                        <p class="name">
                           <span>
                                Current team: {{ currentTeam }}
                           </span>
                            <!--                            <i-->
                            <!--                                class="fas fa-refresh"-->
                            <!--                            >-->
                            <!--                            </i>-->
                        </p>
                    </div>
                    <nav>
                        <ul>
                            <!--                            <li-->
                            <!--                                v-if="!loggedIn"-->
                            <!--                            >-->
                            <!--                                <button-component-->
                            <!--                                    @click="goToLogin"-->
                            <!--                                >-->
                            <!--                                    Log in-->
                            <!--                                </button-component>-->
                            <!--                            </li>-->
                            <!--                            <li-->
                            <!--                                v-if="!loggedIn"-->
                            <!--                            >-->
                            <!--                                <button-component-->
                            <!--                                    color="purple"-->
                            <!--                                >-->
                            <!--                                    Sign up-->
                            <!--                                </button-component>-->
                            <!--                            </li>-->
                            <li
                                v-if="loggedIn"
                            >
                                <button-component
                                    @click="goToLogout"
                                >
                                    Log out
                                </button-component>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
</template>
